import { selectPlan } from 'redux/reducers/plan';
import { useAppSelector } from 'redux/store';

export default function usePlan() {
  const plan = useAppSelector(selectPlan);
  return plan;
}
